import React, { FC, useRef } from "react";
import type { ClearingInstitutionsKeepingYouOutProps } from "@/types";
import { A11y, EffectCoverflow, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { ContentManager } from "../content-manager";
import { SwiperNavigation } from "../swiper";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const ClearingInstitutionsKeepingYouOut: FC<
  ClearingInstitutionsKeepingYouOutProps
> = ({ title, cards }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="clearingInstitutionsKeepingYouOut">
      <div className="wrapper">
        <div ref={ref} className="clearingInstitutionsKeepingYouOut--top">
          <SplitTextAnimation
            htmlElement={
              <h2 className="clearingInstitutionsKeepingYouOut--title">
                {title}
              </h2>
            }
            isInView={isInView}
          />
        </div>
      </div>
      <Swiper
        modules={[A11y, EffectCoverflow, Navigation]}
        effect="coverflow"
        slidesPerView="auto"
        grabCursor
        centeredSlides
        navigation={{
          prevEl:
            ".clearingInstitutionsKeepingYouOut--navigation button:first-of-type",
          nextEl:
            ".clearingInstitutionsKeepingYouOut--navigation button:last-of-type",
        }}
        coverflowEffect={{
          rotate: 0,
          stretch: 200,
          slideShadows: false,
          scale: 0.9,
        }}
        className="clearingInstitutionsKeepingYouOut--swiper"
      >
        <SwiperNavigation className="clearingInstitutionsKeepingYouOut--navigation" />
        {cards.map((slide, index) => {
          return (
            <SwiperSlide
              key={index}
              className="clearingInstitutionsKeepingYouOut--slide"
            >
              <div className="clearingInstitutionsKeepingYouOut--slide-subtitle">
                Problem
              </div>
              {slide.title && (
                <ContentManager
                  content={slide.title}
                  className="clearingInstitutionsKeepingYouOut--slide-title"
                />
              )}
              <div className="clearingInstitutionsKeepingYouOut--slide-descriptionWrapper">
                <div className="clearingInstitutionsKeepingYouOut--slide-ps">
                  Payall Solution
                </div>
                {slide.description && (
                  <ContentManager
                    content={slide.description}
                    className="clearingInstitutionsKeepingYouOut--slide-description"
                  />
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};
